export default {
  dateToYMD: function (date) {
    let year, month, day

    year = String(date.getFullYear())
    month = String(date.getMonth() + 1)

    if (month.length == 1) {
        month = '0' + month
    }

    day = String(date.getDate())

    if (day.length == 1) {
        day = '0' + day
    }

    return year + '-' + month + '-' + day
  },

  formatDateTime: function (value) {
    if (value) {
      if (value === '0001-01-01T00:00:00Z' || value === '0001-01-01') {
        return '-'
      } else {
        const date = value.split('T')[0]
        const time = value.split('T')[1].split('+')[0]

        return date.split('-').reverse().join('-') + ' ' + time
      }
    }
  },

  formatDate: function (value) {
    if (value) {
      if (value === '0001-01-01T00:00:00Z' || value === '0001-01-01') {
        return '-'
      } else {
        const date = value.split('T')[0]

        return date.split('-').reverse().join('-') 
      }
    }
  },

  formatDateTimeWithDay: function (value) {
    const indoDays = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu']
    if (value) {
      if (value === '0001-01-01T00:00:00Z' || value === '0001-01-01') {
        return '-'
      } else {
        const dateObj = new Date(value)
        const day = indoDays[dateObj.getDay()]
        const date = String(dateObj.getDate()).padStart(2, '0')
        const month = String(dateObj.getMonth() + 1).padStart(2, '0')
        const year = dateObj.getFullYear()
        const hours = String(dateObj.getHours()).padStart(2, '0')
        const minutes = String(dateObj.getMinutes()).padStart(2, '0')
        const seconds = String(dateObj.getSeconds()).padStart(2, '0')

        return `${day}, ${date}-${month}-${year} ${hours}:${minutes}:${seconds}`
      }
    }
  },

  formatDateWithDay: function (value) {
    const indoDays = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu']
    if (value) {
      if (value === '0001-01-01T00:00:00Z' || value === '0001-01-01') {
        return '-'
      } else {
        const dateObj = new Date(value)
        const day = indoDays[dateObj.getDay()]
        const date = String(dateObj.getDate()).padStart(2, '0')
        const month = String(dateObj.getMonth() + 1).padStart(2, '0')
        const year = dateObj.getFullYear()

        return `${day}, ${date}-${month}-${year}`
      }
    }
  },

  formatTime: function (value) {
    if (value) {
      if (value === '0001-01-01T00:00:00Z' || value === '0001-01-01') {
        return '-'
      } else {
        const splitDateTime = value.split('T')

        if (splitDateTime.length > 1) {
          return splitDateTime[1].split('+')[0].replace(/Z/g, '')
        } else {
          return '-'
        }

      }
    }
  },

  getDayName: function (dateString) {
    const days = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu']
    const d = new Date(dateString)
    const dayName = days[d.getDay()]

    return dayName
  },

  getMonthName: function (monthIndex) {
    const months = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']

    return months[monthIndex - 1]
  },

  calcMonthDiff: function (dateFrom, dateTo) {
    return dateTo.getMonth() - dateFrom.getMonth() + (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
  },

  formatRupiah: function (value) {
    const prefix = 'Rp '

    const number_string = value.toString()
    // .replace(/[^,\d]/g, '')
    const split = number_string.split('.')
    const sisa = split[0].length % 3

    let rupiah = split[0].substr(0, sisa)
    const ribuan = split[0].substr(sisa).match(/\d{1,3}/gi)

    if(ribuan){
      const separator = sisa ? '.' : ''
      rupiah += separator + ribuan.join('.')
    }

    rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah

    return prefix == undefined ? rupiah : (rupiah ? 'Rp ' + rupiah : '')
  },

  textToTitleCase: function (text) {
    return text.replace(
      /\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    )
  },

  groupBy: function(items, key) {
    return items.reduce(function(accumulatedItem, item) {
      (accumulatedItem[item[key]] = accumulatedItem[item[key]] || []).push(item)
      
      return accumulatedItem
    }, {})
  },

  inputRestrictNumber: function(evt) {
    evt = (evt) ? evt : window.event
    var charCode = (evt.which) ? evt.which : evt.keyCode;

    if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
      evt.preventDefault()
    } else {
      return true
    }

  },

  boleanText: function(value) {
    if (value === 1) {
      return 'Ya'
    } else if (value === 2) {
      return 'Tidak'
    } else {
      return ''
    }
  },

  textColorMarking: function(value, colorType) {
    if (!value) {
      return ''
    }

    if (!colorType) {
      if (value === 0) {
        colorType = 'danger'
        value = 'Tidak'
      } else if (value === 1) {
        colorType = 'success'
        value = 'Iya'
      } else {
        colorType = 'light'
      }
    }

    // <i class="fas fa-check text-success" />
    
    return `<span class="badge badge-${colorType}">${value}</span>`
  },

  // inputMaxNumber: function(evt, val, max) {
  //   evt = (evt) ? evt : window.event
  //   console.log(evt)
  //   console.log(val)
  //   console.log(max)
  // }


  terbilang: function(value){
    function terbilang(a){
      var c=" Satu Dua Tiga Empat Lima Enam Tujuh Delapan Sembilan Sepuluh Sebelas".split(" ");if(12>a)var b=c[a];else 20>a?b=c[a-10]+" Belas":100>a?(b=parseInt(String(a/10).substr(0,1)),b=c[b]+" Puluh "+c[a%10]):200>a?b="Seratus "+terbilang(a-100):1E3>a?(b=parseInt(String(a/100).substr(0,1)),b=c[b]+" Ratus "+terbilang(a%100)):2E3>a?b="Seribu "+terbilang(a-1E3):1E4>a?(b=parseInt(String(a/1E3).substr(0,1)),b=c[b]+" Ribu "+terbilang(a%1E3)):1E5>a?(b=parseInt(String(a/100).substr(0,2)),
      a%=1E3,b=terbilang(b)+" Ribu "+terbilang(a)):1E6>a?(b=parseInt(String(a/1E3).substr(0,3)),a%=1E3,b=terbilang(b)+" Ribu "+terbilang(a)):1E8>a?(b=parseInt(String(a/1E6).substr(0,4)),a%=1E6,b=terbilang(b)+" Juta "+terbilang(a)):1E9>a?(b=parseInt(String(a/1E6).substr(0,4)),a%=1E6,b=terbilang(b)+" Juta "+terbilang(a)):1E10>a?(b=parseInt(String(a/1E9).substr(0,1)),a%=1E9,b=terbilang(b)+" Milyar "+terbilang(a)):1E11>a?(b=parseInt(String(a/1E9).substr(0,2)),a%=1E9,b=terbilang(b)+" Milyar "+terbilang(a)):
      1E12>a?(b=parseInt(String(a/1E9).substr(0,3)),a%=1E9,b=terbilang(b)+" Milyar "+terbilang(a)):1E13>a?(b=parseInt(String(a/1E10).substr(0,1)),a%=1E10,b=terbilang(b)+" Triliun "+terbilang(a)):1E14>a?(b=parseInt(String(a/1E12).substr(0,2)),a%=1E12,b=terbilang(b)+" Triliun "+terbilang(a)):1E15>a?(b=parseInt(String(a/1E12).substr(0,3)),a%=1E12,b=terbilang(b)+" Triliun "+terbilang(a)):1E16>a&&(b=parseInt(String(a/1E15).substr(0,1)),a%=1E15,b=terbilang(b)+" Kuadriliun "+terbilang(a));a=b.split(" ");c=[];for(b=0;b<a.length;b++)""!=a[b]&&c.push(a[b]);return c.join(" ")
    }
      
    return terbilang(value)
  }
}
